<template>
  <b-container fluid>
    <!-- Main table element -->
    <b-table
      :items="planDetails"
      :fields="fields"
      :busy.sync="loading"
      stacked="md"
      show-empty
      @filtered="onFiltered"
      bordered
      borderless
      striped
      empty-filtered-text="لا يوجد نتائج تطابق البحث"
      empty-text="لا يوجد سجلات لعرضها"
    >
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle mx-2"></b-spinner>
          <strong>جاري التحميل...</strong>
        </div>
      </template>
      <template #cell(name)="row">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column">
            <h5 class="mb-0">
              {{ row.value }}
            </h5>
            <small>
              {{ row.item.program ? row.item.program.name : "" }}
            </small>
          </div>
          <b-button
            @click="row.toggleDetails"
            class="btn-icon rounded-circle mr-25"
            variant="flat-secondary"
            size="sm"
            v-if="row.item.executions.length > 0"
          >
            <feather-icon
              size="15"
              :icon="row.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            />
          </b-button>
        </div>
      </template>
      <!-- <template v-for="n in 12" v-slot:[`cell(${n})`]="row">
        <feather-icon
          v-if="row"
          size="15"
          class="text-success"
          icon="CheckCircleIcon"
        />
      </template> -->

      <template #cell(benNum)="row">
        {{ row.item.information.beneficiaries_number }}
      </template>
      <template #cell(funds)="row">
        {{ new Intl.NumberFormat().format(row.item.information.funds) }}
      </template>
      <template v-for="n in 12" v-slot:[`cell(${n})`]="row">
        <feather-icon
          v-if="
            row.item.information.months &&
            (row.item.information.months.includes(n) ||
              row.item.information.months.includes(`${n}`))
          "
          size="15"
          class="text-success"
          icon="CheckCircleIcon"
        />
      </template>
      <template #cell(actions)="row">
        <div class="pr-5 py-1"></div>
      </template>
      <template #row-details="row">
        <b-table
          :fields="detailsFields"
          responsive="sm"
          :items="row.item.executions"
          striped
          hover
          empty-filtered-text="لا يوجد نتائج تطابق البحث"
          empty-text="لا يوجد سجلات لعرضها"
        >
          <template v-for="n in 12" v-slot:[`cell(${n})`]="innerRow">
            <feather-icon
              v-if="
                innerRow.item.months.includes(n) ||
                innerRow.item.months.includes(`${n}`)
              "
              size="15"
              class="text-success"
              icon="CheckCircleIcon"
            />
          </template>

          <template #cell(actions)="innerRow">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item>
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">تعديل</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import {
  BButton,
  BCard,
  BModal,
  BTable,
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BInputGroup,
  BPagination,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    BCard,
    BModal,
    BTable,
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BInputGroup,
    BPagination,
    BFormSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  props: {
    planDetails: Array,
    loading: Boolean,
  },
  data() {
    return {
      items: [
        {
          name: "برنامج محو الأمية",
          num: 2904,
          price: 2500000,
          1: true,
        },
      ],
      fields: [
        {
          key: "name",
          label: "اسم النشاط",
          sortable: true,
          sortDirection: "desc",
          class: "th-width",
        },
        {
          key: "1",
          label: "ك 2",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "2",
          label: "شباط",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "3",
          label: "آذار",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "4",
          label: "نيسان",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "5",
          label: "أيار",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "6",
          label: "حزيران",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "7",
          label: "تموز",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "8",
          label: "آب",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "9",
          label: "أيلول",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "10",
          label: "ت 1",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "11",
          label: "ت 2",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "12",
          label: "ك 1",
          sortable: true,
          class: "text-center px-2",
        },

        {
          key: "benNum",
          label: "عدد المستفيدين",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "funds",
          label: "الموازنة",
          sortable: true,
          class: "text-center px-2",
        },

        { key: "actions", label: "" },
      ],
      detailsFields: [
        {
          key: "name",
          label: "اسم النشاط",
          sortable: true,
          sortDirection: "desc",
          class: "th-width pl-5",
        },
        {
          key: "1",
          label: "ك 2",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "2",
          label: "شباط",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "3",
          label: "آذار",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "4",
          label: "نيسان",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "5",
          label: "أيار",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "6",
          label: "حزيران",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "7",
          label: "تموز",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "8",
          label: "آب",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "9",
          label: "أيلول",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "10",
          label: "ت 1",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "11",
          label: "ت 2",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "12",
          label: "ك 1",
          sortable: true,
          class: "text-center px-2",
        },

        {
          key: "beneficiaries_number",
          label: "عدد المستفيدين",
          sortable: true,
          class: "text-center px-2",
        },
        {
          key: "funds",
          label: "الموازنة",
          sortable: true,
          class: "text-center px-2",
        },

        { key: "actions", label: "" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss">
.b-table-details {
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f8f8f8;
  }
  > td {
    padding-left: 0px;
    padding-right: 0px;
  }
  th {
    padding: 0 2rem;
    visibility: hidden;

    div {
      visibility: hidden;
    }
    font-size: xx-small;
  }
}
.th-width {
  width: 200px;
}
</style>
